import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getSeguradoras(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetSeguradoras(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveSeguradora(seguradora) {
  try {
    const response = await authHttp().post(routes.urlPostSeguradora, seguradora)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
